import {ConstraintsCollection, MarketDataFeedMarkupFilterModel, MarketDataFeedMarkupInterface, ReportFilterConstraintsEnum} from '@spa/api';
import {Pagination} from 'appShared/components';
import {propertyOf} from 'appShared/classes';

export const marketDataFeedMarkupInitialFilterModel = (userId: number, itemsPerPage = Pagination.defaultItemsPerPage) => {
    const filter = new MarketDataFeedMarkupFilterModel(
        new ConstraintsCollection(),
        Pagination.defaultPagesChunk - 1,
        MarketDataFeedMarkupFilterModel.getCreatedTimeSelector(),
        Pagination.calculateItemsPerPagesChunk(itemsPerPage),
        false
    );

    filter.addConstraintItem(
        ReportFilterConstraintsEnum.Equal,
        propertyOf<MarketDataFeedMarkupInterface>('userId'),
        userId
    );

    return filter;
};

export const marketDataFeedMarkupUserIdFilterModel = (userIds: number[], itemsPerPage = Pagination.defaultItemsPerPage) => {
    const filter = new MarketDataFeedMarkupFilterModel(
        new ConstraintsCollection(),
        Pagination.defaultPagesChunk - 1,
        MarketDataFeedMarkupFilterModel.getCreatedTimeSelector(),
        Pagination.calculateItemsPerPagesChunk(itemsPerPage),
        false
    );

    filter.addConstraintItem(
        ReportFilterConstraintsEnum.In,
        propertyOf<MarketDataFeedMarkupInterface>('userId'),
        userIds.join(',')
    );

    return filter;
};
